import { useState } from 'react'

const PAGE_SIZE = 3

export default function ImmobilierSearchHistory({ searches, loading, onSelectSearch, onRelaunch }) {
  const [page, setPage] = useState(1)

  if (loading && searches.length === 0) return null
  if (searches.length === 0) return null

  const totalPages = Math.ceil(searches.length / PAGE_SIZE)
  const paginated = searches.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE)

  return (
    <div style={{ marginTop: 32 }}>
      <h3 style={{ fontSize: 13, color: 'rgb(var(--rgb-ink) / 0.35)', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 12 }}>
        Historique des recherches
      </h3>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        {paginated.map((s) => {
          const parts = [
            s.transactionType,
            s.propertyType,
            (s.locationLabel || s.location) && `à ${s.locationLabel ?? s.location}`,
            s.priceMax && `max ${Number(s.priceMax).toLocaleString()}€`,
            s.surfaceMin && `${s.surfaceMin}m²+`,
          ].filter(Boolean)

          const date = new Date(s.createdAt)
          const dateStr = date.toLocaleDateString('fr-FR', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' })

          return (
            <div
              key={s.id}
              onClick={() => onSelectSearch?.(s)}
              style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 16px', borderRadius: 10, background: 'rgba(91, 92, 244,0.04)', border: '1px solid rgba(91, 92, 244,0.1)', cursor: 'pointer', transition: 'border-color 0.15s' }}
              onMouseEnter={e => e.currentTarget.style.borderColor = 'rgba(91, 92, 244,0.3)'}
              onMouseLeave={e => e.currentTarget.style.borderColor = 'rgba(91, 92, 244,0.1)'}
            >
              <div style={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                <span style={{ fontSize: 13, color: 'rgb(var(--rgb-ink) / 0.7)', fontWeight: 500 }}>
                  {parts.length > 0 ? parts.join(' · ') : 'Recherche sans critères'}
                </span>
                <span style={{ fontSize: 11, color: 'rgb(var(--rgb-ink) / 0.25)' }}>{dateStr}</span>
              </div>
              <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexShrink: 0, marginLeft: 16 }}>
                <div style={{ textAlign: 'right' }}>
                  <div style={{ fontSize: 15, fontWeight: 700, color: '#5b5cf4' }}>{(s.totalResults ?? 0).toLocaleString()}</div>
                  <div style={{ fontSize: 10, color: 'rgb(var(--rgb-ink) / 0.25)' }}>résultats</div>
                </div>
                {s.claimedCount > 0 && (
                  <div style={{ textAlign: 'right' }}>
                    <div style={{ fontSize: 14, fontWeight: 600, color: 'rgba(0,200,100,0.8)' }}>{s.claimedCount}</div>
                    <div style={{ fontSize: 10, color: 'rgb(var(--rgb-ink) / 0.25)' }}>achetées</div>
                  </div>
                )}
                <div style={{ textAlign: 'right' }}>
                  <div style={{ fontSize: 13, color: 'rgb(var(--rgb-ink) / 0.3)' }}>{s.creditsUsed} cr.</div>
                  <div style={{ fontSize: 10, color: 'rgb(var(--rgb-ink) / 0.2)' }}>utilisés</div>
                </div>
                {onRelaunch && (
                  <button
                    onClick={(e) => { e.stopPropagation(); onRelaunch(s) }}
                    style={{ padding: '5px 12px', borderRadius: 6, background: 'rgba(91, 92, 244,0.1)', border: '1px solid rgba(91, 92, 244,0.25)', color: 'rgba(91, 92, 244,0.8)', fontSize: 12, cursor: 'pointer', fontWeight: 500, transition: 'all 0.15s', whiteSpace: 'nowrap' }}
                    onMouseEnter={e => { e.currentTarget.style.background = 'rgba(91, 92, 244,0.2)'; e.currentTarget.style.borderColor = 'rgba(91, 92, 244,0.5)' }}
                    onMouseLeave={e => { e.currentTarget.style.background = 'rgba(91, 92, 244,0.1)'; e.currentTarget.style.borderColor = 'rgba(91, 92, 244,0.25)' }}
                  >
                    ↺ Relancer
                  </button>
                )}
              </div>
            </div>
          )
        })}
      </div>

      {totalPages > 1 && (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12, marginTop: 12 }}>
          <button
            onClick={() => setPage(p => Math.max(1, p - 1))}
            disabled={page === 1}
            style={{ background: 'none', border: '1px solid rgb(var(--rgb-ink) / 0.1)', borderRadius: 6, color: page === 1 ? 'rgb(var(--rgb-ink) / 0.2)' : 'rgb(var(--rgb-ink) / 0.5)', padding: '4px 10px', cursor: page === 1 ? 'default' : 'pointer', fontSize: 13 }}
          >
            ←
          </button>
          <span style={{ fontSize: 12, color: 'rgb(var(--rgb-ink) / 0.3)' }}>{page} / {totalPages}</span>
          <button
            onClick={() => setPage(p => Math.min(totalPages, p + 1))}
            disabled={page === totalPages}
            style={{ background: 'none', border: '1px solid rgb(var(--rgb-ink) / 0.1)', borderRadius: 6, color: page === totalPages ? 'rgb(var(--rgb-ink) / 0.2)' : 'rgb(var(--rgb-ink) / 0.5)', padding: '4px 10px', cursor: page === totalPages ? 'default' : 'pointer', fontSize: 13 }}
          >
            →
          </button>
        </div>
      )}
    </div>
  )
}
